import { firestore } from "@/firebase";
import contextModule from "./context/context.store";
import { pathHead, pathJoin, pathTail } from "../helpers";
import generateState from "./helpers/state.store";
import { set_document, set_document_listener, set_fetch_timestamp } from "./helpers/mutations.store";
import { cache, watch, watch_document, fetch, fetch_document } from "./helpers/actions.store";
import { is_watching, document_listener, stored } from "./helpers/getters.store";
import { id, access } from "./helpers/getters.store";
import { splitPath } from "../helpers";
import { GET, GET_FROM_MODULES, MAYBE_REGISTER_ALL_CONTEXTS } from "./helpers/action.type";
import { ACCESS } from "./helpers/getter.type";
import { CONTEXT, TASKS_MODULE } from "./helpers/module.type";

export const getters = {
  context: state => id => state.contexts[id](),
  cached: state => ({
    name: state.name,
    type: state.type,
    members: state.members,
    contexts: state.contexts
  }),
  contexts: state => state.contexts,
  id,
  access,
  ref: state => firestore.doc(state.ref.path),
  is_watching,
  document_listener,
  stored
};

export const mutations = {
  maybe_register_context(state, context) {
    const ref = firestore.doc(state.ref.path);
    const context_ref = ref.collection("contexts").doc(context.id);
    
    if (!this.hasModule(["user", ref.id, context_ref.id])) {
      this.registerModule(
        ["user", ref.id, context_ref.id],
        contextModule(
          context_ref.id,
          context_ref,
          ref.id
        )
      );
    }
  },
  set_document,
  set_document_listener,
  set_fetch_timestamp
};

export const actions = {
  [GET]: async ({ dispatch }, payload) => {
    await dispatch("cache", payload?.options);
    await dispatch("maybe_register_all_contexts");
    if (pathHead(payload?.path))
      return await dispatch("get_from_modules", payload);
    else
      return getters.cached;
  },
  [GET_FROM_MODULES]: async ({ dispatch }, payload) => {
    // console.important("HERE");
    if (!payload?.path) return;

    const [phead, store, ...path] = splitPath(payload?.path);

    switch (phead) {
      case CONTEXT:
        // The context module should be accessed by the path `context/<context_id>`
        return await dispatch(pathJoin(store, GET), {
          ...payload,
          path: pathJoin(...path),
        });
      
      case TASKS_MODULE:
        // The tasks module does not require any additional information.
        return await dispatch(pathJoin(phead, GET), {
          ...payload,
          path: pathJoin(store, ...path),
        });

      default:
        return getters.access(payload.path);
    };
  },
  [MAYBE_REGISTER_ALL_CONTEXTS]: ({ commit, getters }) => {
    Object.keys(getters.contexts).forEach(key => {
      const context = getters.contexts[key];
      commit("maybe_register_context", context);
    });
  },
  cache,
  watch,
  watch_document,
  fetch,
  fetch_document
};

export const state = (moduleName, ref) => ({
  moduleName,
  ref: ref,
  name: "",
  type: "",
  members: [],
  contexts: [],
  ...generateState()
});

export default (moduleName, ref) => ({
  namespaced: true,
  state: state(moduleName, ref),
  getters,
  mutations,
  actions
});

